










































































































import { Vue, Component, Ref, Watch } from 'vue-property-decorator'
import UserLoginStore from '@/store/vuex/authentication/UserLoginStore'
import { FindPerfilUseCase, FindUsuarioUseCase, LoginUseCase } from '@/usecases'
import { TokenJwt, Credenciais } from '@/models'
import { obrigatorio } from '@/shareds/regras-de-form'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'
import { TipoDeRegraDePermissao } from '@/models/RegraDeNegocio'
import { perfilTemRegraDeNegocio } from '@/shareds/permissoes-shareds'

function gerarCredenciais(): Credenciais {
	return {
		login: '',
		senha: '',
	}
}

@Component
export default class DialogoDeAutenticacao extends Vue {
	@Ref() formDialogoAutenticacao!: HTMLFormElement
	@Ref() campoDeLogin!: HTMLInputElement

	obrigatorio = obrigatorio

	carregando = false
	mostra = false
	mostraErro = false
	regra: TipoDeRegraDePermissao | null = null
	errorMessage = ''
	persistent = false
	validar = true
	autenticacaoPadrao = true



	credenciais = gerarCredenciais()
	resolveDialogo: ((value: boolean) => void) | null = null

	get autenticacaoGeral() {
		return UserLoginStore.autenticando
	}

	async mostrar(
		lojaId?: string | undefined,
		regra?: TipoDeRegraDePermissao,
		persistent = false,
		validar = true,
		autenticacaoPadrao?: boolean,
	): Promise<boolean> {
		if (regra && UserLoginStore.permiteRegraDeNegocio(regra)) return true
		this.mostra = true
		this.regra = regra || null
		this.persistent = persistent
		this.credenciais.lojaId = lojaId
		this.validar = validar
		this.autenticacaoPadrao = autenticacaoPadrao || true

		setTimeout(() => {
			this.campoDeLogin.focus()
			setTimeout(() => {
				this.formDialogoAutenticacao.resetValidation()
			})
		})
		return new Promise<boolean>(resolve => this.resolveDialogo = resolve)
	}

	@Watch('mostra')
	onChangeMostra(mostra: boolean) {
		if (!mostra) {
			this.resolveDialogo && this.resolveDialogo(false)
			return
		}
		this.credenciais = {
			...this.credenciais,
			login: '',
			senha: '',
		}
	}

	fechar() {
		this.mostra = false
	}

	async autenticar(): Promise<void> {
		if (!this.formDialogoAutenticacao.validate()) return
		try {
			this.carregando = true
			const tokenJwt: TokenJwt = await new LoginUseCase().signIn(this.credenciais)
			if (!tokenJwt) throw new Error('Usuário ou senha inválidos')
			if (UserLoginStore.autenticando) await this.validarUsuarioLogado(tokenJwt)
			if (this.regra) await this.validarPermissaoDoLogin(tokenJwt, this.regra)
			this.resolveDialogo && this.resolveDialogo(true)
			this.mostra = false
			this.mostraErro = false
		} catch (error: any) {

			if(UserLoginStore.autenticando) {
				this.errorMessage = error.message;
				this.mostraErro = true
			} else AlertModule.setError(error)
		} finally {
			this.carregando = false
		}
	}

	async validarUsuarioLogado(tokenJwt: TokenJwt) {
		const usuarioLogado = await new FindUsuarioUseCase().usuarioLogado()
		const payload = JSON.parse(atob(tokenJwt.token.split('.')[1]))
		const idUsuario = payload.sub
		const usuario = await new FindUsuarioUseCase().findById(idUsuario)
		if (!usuario) throw new Error('Usuário não encontrado')
		if (usuario.id !== usuarioLogado.id) throw new Error('Credenciais diferem do usuário já logado.')
	}

	async validarPermissaoDoLogin(tokenJwt: TokenJwt, regra: TipoDeRegraDePermissao) {
		const payload = JSON.parse(atob(tokenJwt.token.split('.')[1]))
		const idUsuario = payload.sub
		const usuario = await new FindUsuarioUseCase().findById(idUsuario)
		if (!usuario) throw new Error('Usuário não encontrado')
		const perfil = await new FindPerfilUseCase().findById(usuario.perfil.id)
		if (!perfilTemRegraDeNegocio(perfil, regra)) throw new Error(`Usuário não tem permissão (${this.regra})`)
	}
}
